import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { motion } from "framer-motion"; // Import framer-motion
import { Link, useLocation } from "react-router-dom"; // Import Link and useLocation from react-router-dom

export default function NavigationBar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation(); // Get the current location

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true); // Show nav links after 100px scroll
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Animation variants for consistent motion control
  const fadeInVariant = {
    hidden: { opacity: 0, x: -50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { delay: i * 0.2, duration: 0.6 },
    }),
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5 }} // Fade-in for the navbar container
    >
      <Navbar
        bg="light"
        expand="lg"
        fixed="top"
        className={`py-1 ${scrolled ? "shadow-lg bg-white" : ""}`}
      >
        <Container>
          <Navbar.Brand href="/" className="fw-bold">
            <img src="/images/logo.svg" alt="" className="w-75" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="border-0 shadow-none"
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {/* Home Link */}
              <motion.div
                custom={0} // Pass index for delay
                variants={fadeInVariant}
                initial="hidden"
                animate="visible"
              >
                <Link
                  to="/"
                  className={`nav-link ${
                    location.pathname === "/"
                      ? "text-warning fw-bold"
                      : "fw-medium"
                  }`}
                >
                  Home
                </Link>
              </motion.div>
              {/* About Us Link */}
              <motion.div
                custom={1}
                variants={fadeInVariant}
                initial="hidden"
                animate="visible"
              >
                <Link
                  to="/about"
                  className={`nav-link ${
                    location.pathname === "/about"
                      ? "text-warning fw-bold"
                      : "fw-medium"
                  }`}
                >
                  About Us
                </Link>
              </motion.div>

              {/* Rooms Link */}
              <motion.div
                custom={2} // Pass index for delay
                variants={fadeInVariant}
                initial="hidden"
                animate="visible"
              >
                <Link
                  to="/rooms"
                  className={`nav-link ${
                    location.pathname === "/rooms"
                      ? "text-warning fw-bold"
                      : "fw-medium"
                  }`}
                >
                  Rooms
                </Link>
              </motion.div>

              {/* Bed Space Link */}
              <motion.div
                custom={3}
                variants={fadeInVariant}
                initial="hidden"
                animate="visible"
              >
                <Link
                  to="/bedSpace"
                  className={`nav-link ${
                    location.pathname === "/bedSpace"
                      ? "text-warning fw-bold"
                      : "fw-medium"
                  }`}
                >
                  Bed Space
                </Link>
              </motion.div>

              {/* More Dropdown */}
              <motion.div
                custom={4}
                variants={fadeInVariant}
                initial="hidden"
                animate="visible"
              >
                <NavDropdown
                  title="Partition"
                  id="basic-nav-dropdown"
                  className="fw-medium"
                >
                  <NavDropdown.Item
                    as={Link}
                    to="/couple"
                    className={`fw-bold py-1 ${
                      scrolled ? "bg-white" : "bg-light"
                    }`}
                  >
                    Couple
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/polo"
                    className={`fw-bold py-1 ${
                      scrolled ? "bg-white" : "bg-light"
                    }`}
                  >
                    Polo
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/loop"
                    className={`fw-bold py-1 ${
                      scrolled ? "bg-white" : "bg-light"
                    }`}
                  >
                    Loop
                  </NavDropdown.Item>
                </NavDropdown>
              </motion.div>

              {/* Contact Link */}
              <motion.div
                custom={5}
                variants={fadeInVariant}
                initial="hidden"
                animate="visible"
              >
                <Link
                  to="/contact"
                  className={`nav-link ${
                    location.pathname === "/contact"
                      ? "text-warning fw-bold"
                      : "fw-medium"
                  }`}
                >
                  Contact
                </Link>
              </motion.div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
}
